/**
 * user-channel.js 的 `draw_notice` / `ship_notice` 事件 payload → toast 顯示模型。
 * 欄位缺漏／空字串／非物件一律回 null，不顯示空 toast。
 * @param {*} payload
 * @returns {?{title: string, message: string}}
 */
export function noticeModel(payload) {
    if (payload === null || typeof payload !== 'object') {
        return null;
    }

    const { title, message } = payload;

    if (typeof title !== 'string' || title === '') {
        return null;
    }
    if (typeof message !== 'string' || message === '') {
        return null;
    }

    return { title, message };
}
